import { motion } from "framer-motion";
import { MaskedRevealLines } from "@/components/MaskedReveal";

export default function PageHero({
  eyebrow,
  title,
  description,
  chapter,
  children,
  className = "",
  testId,
}) {
  return (
    <section
      data-testid={testId || "page-hero"}
      className={`relative pt-24 lg:pt-28 pb-12 lg:pb-16 overflow-hidden ${className}`}
    >
      <div aria-hidden className="absolute inset-0 -z-10 dot-grid opacity-70" />
      <div aria-hidden className="absolute -top-40 left-1/2 -translate-x-1/2 h-[500px] w-[500px] rounded-full bg-brand-radial blur-3xl opacity-70" />

      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="font-mono text-[11px] tracking-[0.22em] uppercase text-muted-foreground mb-5"
        >
          <span className="text-brand-gradient font-semibold">{chapter}</span>
          <span className="opacity-40 mx-2">/</span>
          <span>{eyebrow}</span>
        </motion.div>

        <MaskedRevealLines
          as="h1"
          testId="page-hero-title"
          lines={title.split(" / ")}
          className="font-heading font-semibold text-[clamp(2rem,4.4vw,4rem)] leading-[1.04] tracking-[-0.035em] max-w-5xl"
        />

        {description && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.6 }}
            className="mt-6 max-w-2xl text-sm sm:text-base text-muted-foreground leading-relaxed"
          >
            {description}
          </motion.p>
        )}

        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}
